export default __webpack_public_path__ + "static/media/ShowMoreMenu.7d627e01.svg";